/**
 *网站相关接口
 *@author xujinjiang
 *@date 2022/3/30 10:59
 */
import { BaseServiceImpl } from '@/service/BaseServiceImpl';
import {WebsiteUrlConfig} from '@/config/WebsiteUrlConfig';

export class WebsiteServiceImpl extends BaseServiceImpl {
  private static service: WebsiteServiceImpl;

  public static getInstance(): WebsiteServiceImpl {
    if (WebsiteServiceImpl.service == null) {
      WebsiteServiceImpl.service = new WebsiteServiceImpl();
    }

    return WebsiteServiceImpl.service;
  }

  /**
   * 申请开发者
   * @param object
   */
  applyDeveloper(object: any, code: string): Promise<any> {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    const option = BaseServiceImpl.getPostOption();
    option.url = `${WebsiteUrlConfig.apply}?code=${code}`;
    option.data = JSON.stringify(object);
    option.headers['Content-Type'] = BaseServiceImpl.jsonContentType;
    return new Promise((resolve, reject) => {
      self
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }

  /**
   *
   * @param object
   */
  getVerificationCode(phone: string) {
    const option = BaseServiceImpl.getGetOption();
    option.url = WebsiteUrlConfig.verificationCode;
    option.params = {
      phone: phone
    };
    return new Promise((resolve, reject) => {
      this
        .huohuaRequest(option)
        .then(function (res) {
          resolve(res.data);
        })
        .catch(function (error) {
          reject(error);
        });
    });
  }
}
